import { requestPublicJson } from './api.js';

export async function fetchExperts(params = {}) {
  return (await fetchExpertsPage(params)).profiles;
}

export async function fetchExpertsPage(params = {}) {
  const query = new URLSearchParams(Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ''));
  const payload = await requestPublicJson(`/api/experts/public/profiles${query.size ? `?${query}` : ''}`);
  const profiles = Array.isArray(payload?.profiles) ? payload.profiles : [];
  return { profiles, total: Number(payload?.total) || profiles.length, limit: Number(payload?.limit) || profiles.length, offset: Number(payload?.offset) || 0, hasMore: Boolean(payload?.hasMore) };
}

export async function fetchExpertCategories() {
  const payload = await requestPublicJson('/api/experts/public/categories');
  return Array.isArray(payload?.categories) ? payload.categories : [];
}

export async function fetchExpert(slug) {
  const payload = await requestPublicJson(`/api/experts/public/profiles/${encodeURIComponent(slug)}`);
  return payload?.profile || null;
}
